import React from "react";

const TeamMemberPage = () => {
    return <h1>Team Member Dashboard - Manage Assigned Tasks</h1>;
};

export default TeamMemberPage;
